// skinTighteningData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[] | any;
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const skinTightening: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Best Skin Tightening Treatment Dubai | Non-Surgical Firming Solutions",
            "description": "Professional skin tightening treatments in Dubai for firmer, youthful skin. HIFU, RF therapy & advanced techniques to boost collagen. Free consultation available.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/skin-tightening-treatment/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Best Skin Tightening Treatment Dubai | Non-Surgical Firming Solutions",
                "description": "Professional skin tightening treatments in Dubai for firmer, youthful skin. HIFU, RF therapy & advanced techniques to boost collagen. Free consultation available.",
                "url": "https://elitebodyhome.com/services/skin-tightening-treatment/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:54:57+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Skin Tightening Treatment Dubai",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Best Skin Tightening Treatment Dubai | Non-Surgical Firming Solutions",
                "description": "Professional skin tightening treatments in Dubai for firmer, youthful skin. HIFU, RF therapy & advanced techniques to boost collagen. Free consultation available.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Skin Tightening Treatment"],
        "hero": {
            "title": "Skin Tightening Treatment",
            "subtitle": "",
            "description": "Are you worried about your skin losing its firmness and elasticity due to aging, weight loss or other reasons, worry not! Skin tightening treatment at Elite Body Home is the perfect choice to give your skin the firmness it deserves. There are different types of surgical and non-surgical skin tightening options. The ideal one can be chosen according to the therapist's decision. This treatment helps to get incredible results with minimal risks. Look picture perfect and shine like never before!"
        },
        "howItWorks": {
            "title": "How Does Skin Tightening Treatment Work?",
            "description": "Skin tightening treatments work by inducing collagen production, which is the key factor for maintaining the firmness and elasticity of skin. The major concern is, gradually there is fall in the rate of collagen production which leads to skin firmness and sagging."
        },
        "procedureSteps": {
            "heading": "",
            "para": "",
            "steps": [
                {
                    "title": "Consultation & Assessment",
                    "desc": "Our skin care professionals thoroughly examine your skin type, issues and suggest the best treatment for you.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "Pre-Treatment Instructions",
                    "desc": "Instructions for preparation before treatment, which includes stopping medicines, or avoiding skin care products before the treatment.",
                    "icon": "fa-solid fa-list-check"
                },
                {
                    "title": "Cleaning",
                    "desc": "The area where the skin tightening treatment is to be performed is well cleaned so that it's dirt free and treated perfectly.",
                    "icon": "fa-solid fa-bubbles"
                },
                {
                    "title": "Numbing",
                    "desc": "A numbing cream or local anesthesia is applied to reduce the pain or discomfort.",
                    "icon": "fa-solid fa-spray-can-sparkles"
                },
                {
                    "title": "Treatment Application",
                    "desc": "Application of chosen skin tightening technique (HIFU, RF therapy, etc.) to stimulate collagen production.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "Post-Treatment Care",
                    "desc": "Detailed aftercare instructions provided to ensure optimal results and recovery.",
                    "icon": "fa-solid fa-heart-circle-check"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Skin Tightening Treatment",
            "subheading": "",
            "para": "Let your skin get the firmness it deserves with skin tightening treatment in Dubai. These treatments are used to change your overall look and give a smooth and subtle appearance.",
            "items": [
                {
                    "title": "Increases Elasticity",
                    "desc": "Helps to increase the elasticity of tissue, facial outlines and body shape.",
                    "icon": "fa-solid fa-arrows-up-down-left-right"
                },
                {
                    "title": "Natural Look",
                    "desc": "Enjoy long-lasting effects. The advanced and non-invasive treatments motivate your body to heal the tissues naturally.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "High Confidence",
                    "desc": "Stand with pride and gain high confidence. Your skin will help to boost your self-confidence.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "Look Young",
                    "desc": "Retard the appearance of wrinkles as they stimulate the skin's production of collagen and elastin.",
                    "icon": "fa-solid fa-hourglass-start"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Needs Skin Tightening?",
            "subheading": "",
            "para": "Skin tightening is ideal for individuals experiencing sagging skin, fine lines, or a loss of firmness due to aging, weight fluctuations, or post-pregnancy changes. It is also suitable for those who want to prevent early signs of aging or prefer non-surgical solutions to improve skin elasticity and achieve a youthful, rejuvenated appearance.",
            "items": [
                {
                    "title": "Aging Skin Concerns",
                    "desc": "For those noticing sagging skin or loss of facial contours due to natural aging process.",
                    "icon": "fa-solid fa-hourglass-end"
                },
                {
                    "title": "Post-Weight Loss",
                    "desc": "Individuals who have experienced significant weight loss and have loose skin as a result.",
                    "icon": "fa-solid fa-weight-scale"
                },
                {
                    "title": "Preventative Care",
                    "desc": "Those looking to prevent early signs of aging and maintain skin elasticity.",
                    "icon": "fa-solid fa-shield"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "Proper preparation ensures optimal results from your skin tightening treatment. Follow these guidelines before your session:",
            "items": [
                {
                    "title": "Stay Hydrated",
                    "desc": "Well-hydrated skin responds better to treatment and heals faster.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "Avoid Sun Exposure",
                    "desc": "Protect your skin from sun damage for at least 2 weeks before treatment.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Stop Certain Medications",
                    "desc": "Consult your doctor about temporarily stopping blood thinners if applicable.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Clean Skin",
                    "desc": "Arrive with clean skin, free from makeup, lotions or creams.",
                    "icon": "fa-solid fa-soap"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "The results you get by opting for Skin tightening treatment in Dubai are remarkable. It gives a tighter effect to the skin, improving its texture and firmness. It's a gradual progress as well where the more the collagen, the better for months.",
            "items": [
                {
                    "title": "Tighter, Firmer Skin",
                    "desc": "Visible improvement in skin laxity and overall firmness.",
                    "icon": "fa-solid fa-square-check"
                },
                {
                    "title": "Improved Contours",
                    "desc": "Enhanced facial and body contours with reduced sagging.",
                    "icon": "fa-solid fa-face-grin-beam"
                },
                {
                    "title": "Youthful Glow",
                    "desc": "Healthier, more radiant skin with reduced visible signs of aging.",
                    "icon": "fa-solid fa-sparkles"
                },
                {
                    "title": "Long-Lasting Effects",
                    "desc": "Results continue to improve as collagen production increases over time.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Tips",
            "subheading": "",
            "para": "Proper aftercare is essential to maintain and enhance your skin tightening results. Follow these guidelines:",
            "items": [
                {
                    "title": "Keep Skin Hydrated",
                    "desc": "Use recommended moisturizers to maintain skin hydration.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "Avoid Direct Sun Exposure",
                    "desc": "Use broad-spectrum SPF 30+ sunscreen daily.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Skip Harsh Skincare Products",
                    "desc": "Avoid retinoids and exfoliants for at least one week post-treatment.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "No Makeup for 24 Hours",
                    "desc": "Allow skin to breathe and recover immediately after treatment.",
                    "icon": "fa-solid fa-paintbrush"
                },
                {
                    "title": "Healthy Lifestyle",
                    "desc": "Maintain a balanced diet and stay hydrated for optimal results.",
                    "icon": "fa-solid fa-apple-whole"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Does Skin Tightening Really Work?",
                    "answer": "Yes, skin tightening treatments work quite effectively to enhance skin firmness and minimize observable aging signs. Effects will vary based upon the type of treatment and individual factors like age or general state of the skin, but most patients notice significant improvements after the treatments."
                },
                {
                    "question": "Are Skin Tightening Treatments Safe?",
                    "answer": "Generally, skin tightening treatments are safe when done by professionals. Non-invasive methods are designed to reduce the risks involved, but they may cause temporary side effects, such as redness or swelling that typically subside within a few days."
                },
                {
                    "question": "How long does the results of skin tightening treatment last?",
                    "answer": "The duration of skin tightening treatment results depends on the technique used. The results of non-surgical skin tightening typically last for about a year, while surgical options may last longer. Maintenance treatments can help prolong the effects."
                },
                {
                    "question": "Is there any downtime after skin tightening treatments?",
                    "answer": "Most non-surgical skin tightening treatments require little to no downtime. You may experience mild redness or swelling that usually resolves within 24-48 hours, allowing you to return to your normal activities immediately after treatment."
                },
                {
                    "question": "How many sessions are typically needed?",
                    "answer": "The number of sessions needed varies depending on your skin condition and desired results. Most patients see optimal results after 3-6 sessions spaced about 4-6 weeks apart. Your specialist will create a customized treatment plan during your consultation."
                },
                {
                    "question": "When will I see results from skin tightening?",
                    "answer": "You may notice some immediate tightening effects, but the most significant results appear gradually over 2-3 months as new collagen forms. Optimal results typically become visible about 6 months after your final treatment session."
                }
            ]
        },
        "treatmentAreas1": [

        ],
        "treatmentAreas2": [

        ]
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/New-Service-Banner-Image-2.jpg",
            "beforeAfter": [
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/1-4.jpg", "alt": "skin tightening before after" },
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Dysport-Botox-Treatment-in-Dubai-2.jpg", "alt": "HIFU treatment results" },
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/2-3.jpg", "alt": "RF therapy results" }
            ]
        },
        "product": {
            "id": 313,
            "title": "Skin Tightening Package",
            "price": 899,
            "description": "Comprehensive skin tightening treatment package including consultation, multiple sessions, and follow-up care. Our expert team offers advanced HIFU, RF therapy and other techniques tailored to your skin needs."
        }
    },
    "ar": {
        "url": "",
        "meta": {
            "title": "أفضل علاج لشد البشرة في دبي | حلول غير جراحية لشد الوجه والجسم",
            "description": "علاجات شد البشرة الاحترافية في دبي للحصول على بشرة مشدودة وشبابية. تقنيات الهايفو والراديو فريكونسي المتقدمة لتحفيز الكولاجين. استشارة مجانية متاحة.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/ar/services/skin-tightening-treatment/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "أفضل علاج لشد البشرة في دبي | حلول غير جراحية لشد الوجه والجسم",
                "description": "علاجات شد البشرة الاحترافية في دبي للحصول على بشرة مشدودة وشبابية. تقنيات الهايفو والراديو فريكونسي المتقدمة لتحفيز الكولاجين. استشارة مجانية متاحة.",
                "url": "https://elitebodyhome.com/ar/services/skin-tightening-treatment/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:54:57+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "علاج شد البشرة في دبي",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "أفضل علاج لشد البشرة في دبي | حلول غير جراحية لشد الوجه والجسم",
                "description": "علاجات شد البشرة الاحترافية في دبي للحصول على بشرة مشدودة وشبابية. تقنيات الهايفو والراديو فريكونسي المتقدمة لتحفيز الكولاجين. استشارة مجانية متاحة.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "علاج شد البشرة"],
        "hero": {
            "title": "علاج شد البشرة",
            "subtitle": "",
            "description": "هل يُقلقك فقدان بشرتك لمرونتها وتماسكها وظهور الترهلات بسبب التقدم في العمر، أو فقدان الوزن، أو العوامل الأخرى؟ لا داعي للقلق! سيساعك علاج شد البشرة في ايليت بودي هوم على استعادة شباب بشرتك ومنحها التماسك الذي تستحقه، فلدينا العديد من الخيارات الجراحية وغير الجراحية لشد البشرة. تُحدد الطريقة الأنسب لكِ وفقًا لتقييم المتخصصين لضمان تحقيق أفضل النتائج، سيُساعد هذا العلاج في تحقيق نتائج مذهلة مع الحد الأدنى من المخاطر. استمتعي ببشرة مشدودة وإطلالة مثالية!"
        },
        "howItWorks": {
            "title": "كيف يتم علاج شد البشرة؟",
            "description": "تُحفز إجراءات شد الجلد إنتاج الكولاجين فيها، وهو العامل الأساسي للحفاظ على تماسك البشرة وتحسين مروته، حيث إن المشكلة الأساسية للبشرة هي انخفاض معدل إنتاج الكولاجين تدريجيًا مع مرور الوقت، مما يؤدي إلى فقدان تماسك البشرة وترهلها."
        },
        "procedureSteps": {
            "heading": "",
            "para": "",
            "steps": [
                {
                    "title": "الاستشارة والتقييم",
                    "desc": "يفحص خبراؤنا في ايليت بودي هوم بشرتك بعناية لمعرفة نوع البشرة، وتحديد المشاكل، واقتراح العلاج الأنسب لك.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "تعليمات ما قبل العلاج",
                    "desc": "قد تشمل التعليمات التوقف عن تناول بعض الأدوية أو تجنب استخدام مستحضرات العناية بالبشرة قبل بدء العلاج.",
                    "icon": "fa-solid fa-list-check"
                },
                {
                    "title": "تنظيف البشرة",
                    "desc": "تُنظف المنطقة المستهدفة جيدًا لضمان خلوها من الأتربة وتحقيق أفضل النتائج.",
                    "icon": "fa-solid fa-bubbles"
                },
                {
                    "title": "التخدير",
                    "desc": "يُستخدم مخدر موضعي لتخفيف الشعور بالألم أو بعدم الراحة أثناء العلاج.",
                    "icon": "fa-solid fa-spray-can-sparkles"
                },
                {
                    "title": "تطبيق العلاج",
                    "desc": "تطبيق تقنية شد البشرة المختارة (الهايفو، علاج RF، إلخ) لتحفيز إنتاج الكولاجين.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "العناية بعد العلاج",
                    "desc": "تقديم تعليمات العناية التفصيلية لضمان تحقيق أفضل النتائج والتعافي الأمثل.",
                    "icon": "fa-solid fa-heart-circle-check"
                }
            ]
        },
        "benefits": {
            "heading": "المزايا",
            "subheading": "",
            "para": "امنح بشرتك التماسك الذي تستحقه مع علاج شد البشرة في دبي، حيث يساعد هذا العلاج على تحسين مظهرك العام ومنحك بشرة ناعمة ومشدودة.",
            "items": [
                {
                    "title": "تعزيز مرونة البشرة",
                    "desc": "يساعد هذا العلاج على تحسين مرونة الأنسجة وتحسين ملامح الوجه وشكل الجسم.",
                    "icon": "fa-solid fa-arrows-up-down-left-right"
                },
                {
                    "title": "يمنحك مظهر طبيعي",
                    "desc": "استمتع بنتائج تدوم طويلًا، حيث تحفز التقنيات الحديثة وغير الجراحية قدرة الجسم الطبيعية على تجديد الأنسجة.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "استعد ثقتك بنفسك من خلال بشرة أكثر تماسكًا وإشراقًا تمنحك مظهرًا متألقًا.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "مظهر أكثر شبابًا",
                    "desc": "يؤخر علاج شد البشرة في دبي ظهور التجاعيد من خلال تحفيز إنتاج الكولاجين والإيلاستين للحفاظ على بشرة شابة ونضرة.",
                    "icon": "fa-solid fa-hourglass-start"
                }
            ]
        },
        "eligibility": {
            "heading": "من يحتاج إلى علاج شد البشرة؟",
            "subheading": "",
            "para": "يعد شد البشرة خيارًا مثاليًا لمن يعاني من ترهل الجلد، أو الخطوط الرفيعة، أو فقدان تماسك البشرة نتيجة التقدم في العمر، أو تغيرات الوزن، أو ما بعد الحمل. كما إنه يناسب من يرغب في منع ظهور علامات الشيخوخة المبكرة أو من يفضّل الحلول غير الجراحية لتعزيز مرونة البشرة والحصول على مظهر شبابي ومتجدد.",
            "items": [
                {
                    "title": "مشاكل البشرة الناتجة عن التقدم في العمر",
                    "desc": "لمن يعاني من ترهل الجلد أو فقدان ملامح الوجه بسبب الشيخوخة الطبيعية.",
                    "icon": "fa-solid fa-hourglass-end"
                },
                {
                    "title": "بعد فقدان الوزن",
                    "desc": "الأفراد الذين فقدوا وزنًا كبيرًا ويعانون من ترهل الجلد نتيجة لذلك.",
                    "icon": "fa-solid fa-weight-scale"
                },
                {
                    "title": "العناية الوقائية",
                    "desc": "لمن يرغب في منع علامات الشيخوخة المبكرة والحفاظ على مرونة البشرة.",
                    "icon": "fa-solid fa-shield"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد للعلاج",
            "subheading": "",
            "para": "يضمن التحضير الجيد تحقيق أفضل النتائج من علاج شد البشرة. اتبع هذه الإرشادات قبل جلسة العلاج:",
            "items": [
                {
                    "title": "حافظ على ترطيب البشرة",
                    "desc": "تستجيب البشرة المرطبة بشكل أفضل للعلاج وتتعافى بسرعة أكبر.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "تجنب التعرض للشمس",
                    "desc": "احم بشرتك من أضرار الشمس لمدة أسبوعين على الأقل قبل العلاج.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "توقف عن بعض الأدوية",
                    "desc": "استشر طبيبك حول التوقف المؤقت عن مميعات الدم إذا كانت تنطبق عليك.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "بشرة نظيفة",
                    "desc": "احرص على أن تكون بشرتك نظيفة وخالية من المكياج أو المستحضرات قبل الجلسة.",
                    "icon": "fa-solid fa-soap"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يمنحك علاج شد البشرة في دبي نتائج مذهلة، حيث يعمل على شد البشرة وتحسين ملمسها وتماسكها وتظهر النتائج بشكل تدريجي فكلما ازداد إنتاج الكولاجين زادت فعالية النتائج واستمرت لعدة أشهر.",
            "items": [
                {
                    "title": "بشرة أكثر تماسكًا",
                    "desc": "تحسن واضح في ترهل البشرة وتماسكها العام.",
                    "icon": "fa-solid fa-square-check"
                },
                {
                    "title": "تحسن ملامح الوجه والجسم",
                    "desc": "تحسن في ملامح الوجه والجسم مع تقليل الترهلات.",
                    "icon": "fa-solid fa-face-grin-beam"
                },
                {
                    "title": "إشراقة شبابية",
                    "desc": "بشرة أكثر صحة وإشراقًا مع تقليل علامات الشيخوخة الظاهرة.",
                    "icon": "fa-solid fa-sparkles"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "تستمر النتائج في التحسن مع زيادة إنتاج الكولاجين بمرور الوقت.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح العناية بعد العلاج",
            "subheading": "",
            "para": "تعتبر العناية الصحيحة بعد العلاج ضرورية للحفاظ على النتائج وتعزيزها. اتبع هذه الإرشادات:",
            "items": [
                {
                    "title": "حافظ على ترطيب البشرة",
                    "desc": "استخدم المرطبات الموصى بها للحفاظ على ترطيب البشرة.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "تجنب التعرض المباشر لأشعة الشمس",
                    "desc": "استخدم واقي شمس واسع الطيف بعامل حماية 30+ يوميًا.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "تجنب مستحضرات العناية القاسية",
                    "desc": "تجنب الريتينويدات والمقشرات لمدة أسبوع على الأقل بعد العلاج.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "تجنب المكياج لمدة 24 ساعة",
                    "desc": "اترك البشرة تتنفس وتتعافى مباشرة بعد العلاج.",
                    "icon": "fa-solid fa-paintbrush"
                },
                {
                    "title": "نمط حياة صحي",
                    "desc": "حافظ على نظام غذائي متوازن ورطوبة كافية لتحقيق أفضل النتائج.",
                    "icon": "fa-solid fa-apple-whole"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "هل علاج شد البشرة فعّال؟",
                    "answer": "نعم، يعتبر علاج شد البشرة فعّال في تحسين تماسك الجلد والتخفيف من علامات التقدم في العمر، وتختلف النتائج حسب نوع العلاج وبعض العوامل مثل العمر وحالة البشرة العامة، ولكن غالبية المرضى يلاحظون تحسنًا ملحوظًا بعد الجلسات."
                },
                {
                    "question": "هل علاج شد البشرة آمن؟",
                    "answer": "نعم، يعد علاج شد البشرة آمن بشكل عام عند إجرائه بواسطة مختصين، حيث صُممت التقنيات غير الجراحية للحد من المخاطر المحتملة ،ومع ذلك قد تظهر بعض الآثار الجانبية المؤقتة مثل الاحمرار أو التورم التي تختفي عادةً في غضون أيام قليلة."
                },
                {
                    "question": "كم تدوم نتائج علاج شد البشرة؟",
                    "answer": "تعتمد مدة النتائج على التقنية المستخدمة، حيث تدوم نتائج شد البشرة غير الجراحي لمدة عام تقريبًا، بينما تدوم نتائج العلاج الجراحي لفترة أطول. يمكن أن تساعد جلسات المتابعة في إطالة مدة النتائج."
                },
                {
                    "question": "هل هناك فترة نقاهة بعد علاج شد البشرة؟",
                    "answer": "معظم علاجات شد البشرة غير الجراحية لا تتطلب أي فترة نقاهة تذكر. قد تعاني من احمرار أو تورم خفيف يختفي عادةً خلال 24-48 ساعة، مما يسمح لك بالعودة إلى أنشطتك الطبيعية مباشرة بعد العلاج."
                },
                {
                    "question": "كم عدد الجلسات المطلوبة عادةً؟",
                    "answer": "يختلف عدد الجلسات المطلوبة حسب حالة بشرتك والنتائج المرجوة. يرى معظم المرضى نتائج مثالية بعد 3-6 جلسات تفصل بينها حوالي 4-6 أسابيع. سيضع أخصائيونا خطة علاج مخصصة خلال استشارتك."
                },
                {
                    "question": "متى سأرى نتائج علاج شد البشرة؟",
                    "answer": "قد تلاحظ بعض تأثيرات الشد الفورية، ولكن تظهر النتائج الأكثر وضوحًا تدريجيًا على مدار 2-3 أشهر مع تكوين كولاجين جديد. تظهر النتائج المثالية عادةً بعد حوالي 6 أشهر من جلسة العلاج الأخيرة."
                }
            ]
        },
        "treatmentAreas1": [

        ],
        "treatmentAreas2": [

        ]
    }
}